// States
import { ConnectedState } from './connectedVisibleConnectionState';
import { ConnectingState } from './connectingVisibleConnectionState';
import { InterruptedState } from './interruptedVisibleConnectionState';
import { DisconnectedState } from './disconnectedVisibleConnectionState';
import { IdleState } from './idleVisibleConnectionState';

// Selectors
import { isGuestSelector } from '../../user/currentUserSelector';
import { selectIsSocketConnected } from '../../utils/socket/socketConnectionSelector';

// Types
import { UnknownAction } from 'redux';
import { ReduxStore } from '../../types/reduxTypes';
import { StateMachine } from '../../../common/utils/lib/stateMachine';

/**
 * Electron apps that aren't starting fresh, might begin with a connection
 *  in this case we want to start with the connected state.
 *
 * Guest users won't even be attempting to connect, so we want to start with the disconnected state.
 */
const getInitialState = (store: ReduxStore) => {
    const state = store.getState();
    const isSocketConnected = selectIsSocketConnected(state);

    if (isSocketConnected) return ConnectedState;

    const isGuest = isGuestSelector(state);
    return isGuest ? IdleState : ConnectingState;
};

/**
 * Middleware that will prevent the reconnection spinner from unnecessarily showing
 * when the app is being restored from the background.
 */
export default (store: ReduxStore) => {
    // Electron apps that aren't starting fresh, might begin with a connection
    //  in this case we want to start with the connected state
    const InitialStateClass = getInitialState(store);

    const visibilityStateMachine = new StateMachine(
        [IdleState, ConnectingState, ConnectedState, InterruptedState, DisconnectedState],
        InitialStateClass,
    );
    return (next: Function) =>
        (action: UnknownAction): UnknownAction => {
            visibilityStateMachine.onAction(action, store);
            return next(action);
        };
};
